import { createElement } from "react";
import { cn } from "../utils";
import { textVariants } from "./text.styles";
/**
 * Text component following Material Design 3 type scale.
 *
 * Supports all MD3 typography variants from display to label sizes.
 *
 * @example
 * ```tsx
 * <Text variant="headlineMedium">Welcome</Text>
 * <Text variant="bodyMedium" color="secondary">Description text</Text>
 * <Text as="h1" variant="displayLarge">Page Title</Text>
 * ```
 */
export function Text({ variant = "bodyMedium", color = "default", align = "left", as = "p", truncate = false, className, style, children, ref, ...props }) {
    return createElement(as, {
        ref,
        className: cn(textVariants({ variant, color, align, truncate }), className),
        style,
        ...props,
    }, children);
}
//# sourceMappingURL=Text.js.map